import { html, render } from './lib/html.js';
import { initI18n } from './lib/i18n.js';
import './lib/theme.js';
import { App } from './app.js';

initI18n()
  .catch(() => {})
  .then(() => render(html`<${App} />`, document.getElementById('app')));
